import { jwtDecode } from "jwt-decode";

export const isTokenValid = (tokenKey = "access_token") => {
    const token = sessionStorage.getItem(tokenKey);
    if (!token) return false;

    try {
        const { exp } = jwtDecode(token);
        const now = Date.now() / 1000;
        return exp > now;
    } catch (e) {
        return false;
    }
};